import { render, staticRenderFns } from "./TigrosCard.vue?vue&type=template&id=f817c8f4"
import script from "./TigrosCard.vue?vue&type=script&lang=js"
export * from "./TigrosCard.vue?vue&type=script&lang=js"
import style0 from "./TigrosCard.vue?vue&type=style&index=0&id=f817c8f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports